import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ReceiptService } from 'app/services/receipt-service';
import { ReceiptParamDTO } from 'app/header-footer-template/model/ReceiptParamDTO';
import { ToastrService } from 'ngx-toastr';
import { CommonsText } from 'app/commons/CommonsText';
import { ActionItem } from '../../actions-dropdown/actions-dropdown.component';

@Component({
    selector: 'app-profile-receipts',
    templateUrl: './profile-receipts.component.html',
    styleUrls: ['./profile-receipts.component.scss']
})
export class ProfileReceiptsComponent implements OnInit {

    filtersOpen = true;
    loading = false;
    response: any;

    filters = {
        product: '',
        statusType: '',
        policyNumber: '',
        policyCollective: '',
        startDate: '',
        endDate: ''
    };

    productList: any[] = [];
    statusTypeList: any[] = [];

    private params = new ReceiptParamDTO();

    constructor(
        private receiptService: ReceiptService,
        private toastr: ToastrService,
        private router: Router
    ) {}

    ngOnInit(): void {
        this.params.pageOffset = 0;
        this.params.pageSize = 10;
        this.search();

        this.receiptService.observerPageSizeChange().subscribe((result: any) => {
            this.params.pageOffset = 0;
            this.params.pageSize = result;
            window.scrollTo(0, 0);
            this.search();
        });

        this.receiptService.observerPageOffset().subscribe((result: any) => {
            this.params.pageOffset = result;
            window.scrollTo(0, 0);
            this.search();
        });

        this.receiptService.observerPageFilter().subscribe((result: any) => {
            this.params.startDate = result.startDate;
            this.params.endDate = result.endDate;
            this.params.statusType = result.statusType;
            this.params.policyNumber = result.policyNumber;
            this.params.product = result.product;
            this.params.policyCollective = result.policyCollective;
            this.params.policyItems = [];
            this.search();
        });
    }

    search(): void {
        this.loading = true;
        this.receiptService.search(this.params)
            .then(success => {
                this.loading = false;
                this.response = success;
                if (success) {
                    this.productList = success.product || [];
                    this.statusTypeList = success.statusType || [];
                    if (success.content) {
                        success.content.forEach(item => {
                            item.payActions = this.buildPayActions(item);
                        });
                    }
                }
            })
            .catch(() => {
                this.loading = false;
                this.response = null;
                this.toastr.error(CommonsText.PROBLEMA_SERVICIO_RECIBOS, CommonsText.PROBLEMA_DE_CONECTIVIDAD, {
                    timeOut: 5000
                });
            });
    }

    toggleFilters(): void {
        this.filtersOpen = !this.filtersOpen;
    }

    applyFilters(): void {
        this.receiptService.setPageFilter({
            startDate: this.filters.startDate,
            endDate: this.filters.endDate,
            statusType: this.filters.statusType ? [{ id: this.filters.statusType }] : [],
            policyNumber: this.filters.policyNumber,
            product: this.filters.product ? [{ id: this.filters.product }] : [],
            policyCollective: this.filters.policyCollective,
            policyItems: []
        });
    }

    pay(data: any): void {
        this.receiptService.payment(data);
    }

    private buildPayActions(item: any): ActionItem[] {
        return [
            {
                label: 'Tarjeta',
                icon: 'card',
                action: () => this.pay(item)
            },
            {
                label: 'Cuenta bancaria',
                icon: 'bank',
                action: () => this.router.navigate(['/receipt', 'nw', item.receiptNumber])
            }
        ];
    }

    download(data: any): void {
        // TODO: wire to PDF download endpoint when available
    }

    isPending(item: any): boolean {
        return item.receiptStatusColor === 'red';
    }

    get currentPage(): number {
        return this.response ? this.response.number + 1 : 1;
    }

    getPages(): (number | null)[] {
        if (!this.response || !this.response.totalPages) { return []; }
        const total = this.response.totalPages;
        const current = this.currentPage;

        if (total <= 7) {
            return Array.from({ length: total }, (_, i) => i + 1);
        }

        let start = Math.max(1, current - 2);
        let end = Math.min(total, current + 2);

        if (end - start < 4) {
            if (start === 1) { end = Math.min(total, 5); }
            else { start = Math.max(1, end - 4); }
        }

        const pages: (number | null)[] = [];

        if (start > 1) {
            pages.push(1);
            if (start > 2) { pages.push(null); }
        }

        for (let i = start; i <= end; i++) { pages.push(i); }

        if (end < total) {
            if (end < total - 1) { pages.push(null); }
            pages.push(total);
        }

        return pages;
    }

    prev(): void {
        if (!this.loading && this.response && !this.response.first) {
            this.receiptService.setPageOffset(this.response.number - 1);
        }
    }

    next(): void {
        if (!this.loading && this.response && !this.response.last) {
            this.receiptService.setPageOffset(this.response.number + 1);
        }
    }

    goToPage(p: number): void {
        if (!this.loading) {
            this.receiptService.setPageOffset(p - 1);
        }
    }
}
